import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import DateFnsUtils from '@date-io/date-fns';
import AmountInput from '../Inputs/AmountInput'
import * as logger from '../../../logger';
import { Form } from 'react-final-form';
import TextInputState from '../Inputs/TextInputState';
import {
    Grid,
    IconButton,
    Button,
    InputAdornment,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CloseIcon from '@material-ui/icons/Close';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AddChargeDeductionType from '../Trip/AddChargeDeductionType';
import {
    getDeductionTypes,
    getChargeTypes,
    addPartyDeduction,
    addPartyCharge,
    editPartyCharge,
    editPartyDeduction
} from "../../../store/actions/tripActionCreator";
import { getMilliDatePickerDateInStringDDMMMYYYY, numberFormat, numberWithCommas, replaceCommas, sendSucces, getVehicleNumberValuesDWeb } from '../../../utils/utils';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import {
    ADD_PARTY_DEDUCTION_SUCCESS,
    ADD_PARTY_CHARGE_SUCCESS,
    UPDATE_PARTY_REDUCTION_SUCCESS,
    UPDATE_PARTY_CHARGE_SUCCESS
} from "../../../store/constants";

const expenseTypefilter = createFilterOptions({
    limit: 30
});

const useStyles = makeStyles(() => ({

    dialogTitleV1: {
        paddingTop: 10,
        paddingBottom: '10px !important',
        paddingLeft: 30,
        paddingRight: 18,
        backgroundColor: 'white'
    },
    paperWidthV1: {
        width: '420px !important'
    },
    brV1: {
        borderRadius: '8px !important'
    },
    divAlignTitle: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    titleText: {
        fontSize: 20,
        fontWeight: 600,
        color: '#0b1323'
    },
    closeIcon: {
        color: '#9ea0a5',
        fontSize: 20
    },
    dialogContentV1: {
        paddingBottom: '32px !important',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: '#f6f6f8'
    },
    dialogActionsV1: {
        paddingTop: 20,
        paddingBottom: '20px !important',
        paddingLeft: 30,
        paddingRight: 30
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#161f34',
        color: 'white',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#161f34'
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#e2e2e2 !important',
        color: 'rgba(11, 19, 35, 0.6) !important',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#e2e2e2 !important'
        }
    },
    cancelButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        marginRight: 16,
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    gridV1: {
        borderRadius: 8,
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed',
        padding: 16
    },
    dotV1: {
        color: '#c4c4c4',
        marginLeft: 4,
        marginRight: 4,
        fontSize: 8
    },
    fw600: {
        fontWeight: 600
    },
    gridText: {
        fontSize: 16,
        color: '#0b1323'
    },
    gridV2: {
        fontSize: 12
    },
    titleV1: {
        fontSize: '14px',
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    formRadio: {
        '& .MuiRadio-root': {
            color: '#6200ee'
        }
    },
    addExpenseListItem: {
        padding: '12px 15px',
        margin: 0,
        backgroundColor: '#0b1323',
        color: '#fff',
        fontWeight: 300,
        minHeight: 46,
        width: '100%',
        maxHeight: 46
    },
    addExpenseIcon: {
        color: '#fff',
        marginRight: 10
    },
    cherveRightIcon: {
        marginLeft: 10,
        float: 'right',
        color: '#fff'
    },
    expenseTypeListItem: {
        padding: '12px 15px',
        minHeight: 46,
        margin: 0,
        maxHeight: 46,
        width: '100%'
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0
    },
    listBoxOption: {
        padding: 0,
        minHeight: 46,
        maxHeight: 46,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    popUpIndicator: {
        display: 'none'
    },
    eventIcon: {
        color: 'grey'
    },
    mtV2: {
        marginTop: 4
    },
    mtV1: {
        marginTop: 16
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    mlV1: {
        marginLeft: 4
    },
    divAlign: {
        display: 'flex'
    }

}));


const AddChargeDeductionDialog = ({ open, onClose, onConfirm, tripData, tripIdValue, user, trip, dispatchGetCharges, dispatchGetDeductions, dispatchAddPartyDeductionAction, dispatchAddPartyChargeAction, transactDataValue, dispatchEditPartyDeductionAction, dispatchEditPartyCharges }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [chargeOrDeductionBillingType, setChargeOrDeductionBillingType] = useState("add_to_bill");
    const [chargeTypeList, setChargeTypeList] = useState([]);
    const [deductionTypeList, setDeductionTypeList] = useState([]);
    const [chargeOrDeductionType, setChargeOrDeductionType] = useState({});
    const [checkType, setCheckType] = useState("");
    const [addChargeDeduction, setAddChargeDeduction] = useState(false);
    const [chargeOrDeductionAmount, setChargeOrDeductionAmount] = useState(null);
    const [notesValue, setNotesValue] = useState("");
    const [chargeOrDeductionDate, setChargeOrDeductionDate] = useState(new Date());
    const [deductionCheck, setDeductionCheck] = useState(false);
    const [changeFlag, setChangeFlag] = useState(false);

    const classes = useStyles();

    const initialValues = {
        billing_type: chargeOrDeductionBillingType,
        chargeOrDeduction_type: chargeOrDeductionType,
        amount: chargeOrDeductionAmount ? numberWithCommas(chargeOrDeductionAmount) : "",
        transactionDate: chargeOrDeductionDate,
        notes: notesValue
    }

    useEffect(() => {
        dispatchGetCharges(
            (data) => {
                if (data && data.status && data.status.code && data.status.code == 200) {
                    logger.log('Add Charge Deduction Dialog Dweb', 'Get Trip Charges Successfull');
                    dispatchGetDeductions(
                        (data) => {
                            if (data && data.status && data.status.code && data.status.code == 200) {
                                logger.log('Add Charge Deduction Dialog Dweb', 'Get Trip Deductions Successfull');
                            }
                        },
                        () => {
                            logger.log('Add Charge Deduction Dialog Dweb', 'Get Trip Deductions Failed');
                        }
                    )
                }
            },
            () => {
                logger.log('Add Charge Deduction Dialog Dweb', 'Get Trip Charges Failed');
            }
        )
    }, [open])

    useEffect(() => {

        if (trip && trip.tripChargeType) {
            setChargeTypeList(trip.tripChargeType);
        }

        if (trip && trip.tripDeductionType) {
            setDeductionTypeList(trip.tripDeductionType);
        }

    }, [trip.tripDeductionType, trip.tripChargeType]);

    useEffect(() => {

        if (transactDataValue && transactDataValue.id) {

            if (transactDataValue.amount && transactDataValue.amount > 0) {
                setChargeOrDeductionBillingType('add_to_bill')
            } else if (transactDataValue.amount && transactDataValue.amount < 0) {
                setChargeOrDeductionBillingType('reduce_from_bill')
            }

            setChargeOrDeductionDate(transactDataValue.date ? new Date(transactDataValue.date * 1000) : new Date());
            setNotesValue(transactDataValue.description ? transactDataValue.description : "");
            setChargeOrDeductionType({
                display: transactDataValue.displayName ? transactDataValue.displayName : "",
                value: transactDataValue.transactionType ? transactDataValue.transactionType : ""
            });
            setChargeOrDeductionAmount(transactDataValue.amount ? numberWithCommas(Math.abs(transactDataValue.amount)) : '')
        }

    }, [open, transactDataValue]);

    useEffect(() => {
        if (changeFlag) {
            setChargeOrDeductionType({});
        }
    }, [deductionCheck])

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onSubmit = async values => {

        let { billing_type, chargeOrDeduction_type, transactionDate, amount, notes } = values;

        let deduction = billing_type && billing_type === 'reduce_from_bill' ? true : false;
        let request = {
            "amount": Number(replaceCommas(amount)),
            "description": notes ? notes : '',
            "expenseDate": transactionDate ? Math.round(new Date(transactionDate).setHours(0, 0, 0, 0) / 1000) : 0,
            "type": chargeOrDeduction_type && chargeOrDeduction_type.value ? chargeOrDeduction_type.value : ''
        }

        if (transactDataValue && transactDataValue.id) {

            if (deduction) {
                dispatchEditPartyDeductionAction(tripIdValue, transactDataValue.id, request,
                    (response) => {
                        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
                            sendSucces(UPDATE_PARTY_REDUCTION_SUCCESS);
                            setDialogOpen(false);
                            onConfirm();
                        } else {
                        }
                    },
                    () => {
                    }
                )
            } else if (!deduction) {
                dispatchEditPartyCharges(tripIdValue, transactDataValue.id, request,
                    (response) => {
                        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
                            sendSucces(UPDATE_PARTY_CHARGE_SUCCESS);
                            setDialogOpen(false);
                            onConfirm();
                        } else {
                        }
                    },
                    () => {
                    }
                )
            }

        } else {

            if (deduction) {
                dispatchAddPartyDeductionAction(tripIdValue, request,
                    (response) => {
                        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
                            sendSucces(ADD_PARTY_DEDUCTION_SUCCESS);
                            setDialogOpen(false);
                            onConfirm();
                        }
                    },
                    () => {
                        //sendError(ADD_PARTY_DEDUCTION_FAILURE)
                    })
            } else if (!deduction) {
                dispatchAddPartyChargeAction(tripIdValue, request,
                    (response) => {
                        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
                            sendSucces(ADD_PARTY_CHARGE_SUCCESS);
                            setDialogOpen(false);
                            onConfirm();
                        }
                    },
                    () => {
                        //sendError(ADD_PARTY_CHARGE_FAILURE)
                    })
            }
        }

    }

    const validate = (values) => {

        const errors = {};

        if (values && !values.chargeOrDeduction_type) {
            errors.chargeOrDeduction_type = "Please Select a Type."
        }

        if (values && !values.amount) {
            errors.amount = "Please enter amount.";
        }

        if (values && !values.transactionDate) {
            errors.transactionDate = "Please select date.";
        }


        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;

    }

    const getFormFields = (values) => {

        let { billing_type } = values;
        let deduction = billing_type && billing_type === 'reduce_from_bill' ? true : false;
        setDeductionCheck(deduction);

        return [
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV1}>
                        <Radios
                            label=""
                            name="billing_type"
                            formControlProps={{ margin: 'none' }}
                            radioGroupProps={{ row: true }}
                            onChange={(e) => { setChargeOrDeductionBillingType(e.target.value); setChangeFlag(true); }}
                            formControlLabelProps={{
                                classes: {
                                    root: classes.formRadio
                                }
                            }}
                            data={[
                                { label: 'Add to Bill', value: 'add_to_bill' },
                                { label: 'Reduce from Bill', value: 'reduce_from_bill' },
                            ]}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Charge Type</div>
                        <Autocomplete
                            id="select-chargeOrDeduction-type-list"
                            name="chargeOrDeduction_type"
                            size="small"
                            classes={{
                                listbox: classes.listBoxAutoCompelete,
                                option: classes.listBoxOption,
                                popupIndicator: classes.popUpIndicator,
                                root: classes.textFieldV1
                            }}
                            required={true}
                            autoHighlight
                            value={chargeOrDeductionType}
                            className={classes.mtV2}
                            onChange={(event, newValue) => {
                                if (typeof newValue === 'string') {
                                    // timeout to avoid instant validation of the dialog's form.
                                    setTimeout(() => {
                                        setChargeOrDeductionType('');
                                    });
                                } else if (newValue && newValue.inputValue) {
                                    setChargeOrDeductionType(newValue);
                                } else if (newValue && newValue.inputValue === '') {
                                    setChargeOrDeductionType('');
                                } else if (newValue && newValue.value) {
                                    setChargeOrDeductionType(newValue && newValue.value ? newValue : null);
                                } else {
                                    setChargeOrDeductionType('');
                                }
                            }}
                            filterOptions={(options, params) => {

                                const filtered = expenseTypefilter(options, params);

                                if (params.inputValue.trim().length > 0 && filtered && filtered.length == 0) {
                                    filtered.unshift({
                                        inputValue: params.inputValue,
                                        display: params.inputValue && params.inputValue.length > 1 ? `Add "${params.inputValue}"` : ``,
                                        add: true
                                    });
                                }

                                return filtered;
                            }}
                            options={deduction ? deductionTypeList && deductionTypeList.length > 0 ? deductionTypeList : [] : chargeTypeList && chargeTypeList.length > 0 ? chargeTypeList : []}
                            handleHomeEndKeys
                            //groupBy={(option) => option.group}
                            getOptionValue={option => option.value}
                            getOptionLabel={(option) => {
                                // e.g value selected with enter, right from the input
                                if (typeof option === 'string') {
                                    return '';
                                }
                                if (option.inputValue || !option.value) {
                                    return '';
                                }
                                return option && option.display ? option.display : ''
                            }}
                            renderOption={(option, { selected, inputValue }) => {
                                let matchesName = match(option.display, inputValue);
                                let partsName = parse(option.display, matchesName);
                                if (option && option.display && !option.add) {
                                    return (
                                        <div className={classes.expenseTypeListItem}>
                                            {partsName.map((part, index) => {
                                                return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                                    {part.text}
                                                </span>
                                                )
                                            })}
                                        </div>
                                    );

                                } else {
                                    if (option && option.add && option.display) {
                                        return (
                                            <div className={classes.addExpenseListItem} onClick={() => handleAddCargeDeduction(deduction ? "deduction" : "charges")}>
                                                <AddCircleOutlineIcon className={classes.addExpenseIcon} />
                                                <span>{option.display}</span>
                                                <ChevronRightIcon className={classes.cherveRightIcon} />
                                            </div>
                                        );
                                    }
                                }
                            }}
                            textFieldProps={
                                {
                                    placeholder: deduction ? "Select a Deduction Type" : "Select a Charge Type",
                                    variant: "outlined",
                                    margin: 'none',
                                    name: "chargeOrDeduction_type",
                                }
                            }
                            multiple={false}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>{deduction ? 'Deduction Amount' : 'Charge Amount'}</div>
                        <AmountInput
                            placeholder="Amount"
                            name="amount"
                            variant="outlined"
                            size="small"
                            margin="none"
                            onChange={(e) => {
                                setChargeOrDeductionAmount(e.target.value)
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>{deduction ? 'Deduction Date' : 'Charge Date'}</div>
                        <DatePicker
                            disableFuture
                            name="transactionDate"
                            margin="none"
                            variant="inline"
                            inputVariant="outlined"
                            size="small"
                            format="dd-MM-yyyy"
                            onChange={(date) => { setChargeOrDeductionDate(date) }}
                            placeholder="Enter a Date"
                            required={true}
                            dateFunsUtils={DateFnsUtils}
                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Notes</div>
                        <TextInputState
                            placeholder="Enter Notes"
                            name="notes"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setNotesValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            }
        ]
    }

    const handleAddCargeDeduction = (type) => {
        setAddChargeDeduction(true);
        setCheckType(type);
    }

    const handleAddChargeDeductionClose = () => {
        setChargeOrDeductionType("");
        setAddChargeDeduction(false);
        setCheckType("");
    }

    const handleAddChargeDeductionSave = (response) => {
        setChargeOrDeductionType(response);
        setAddChargeDeduction(false);
        setCheckType("");
    }


    return (
        <>
            <Dialog
                open={dialogOpen}
                onClose={handleClose}
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                classes={{ paperWidthXs: classes.paperWidthV1, paperScrollPaper: classes.brV1 }}
                maxWidth="xs"
            >

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divAlignTitle}>
                        <div className={classes.titleText}>
                            {transactDataValue && transactDataValue.id ?
                                <>
                                    Edit Charge
                                </>
                                :
                                <>
                                    Add Charge
                                </>
                            }

                        </div>
                        <IconButton aria-label="close" onClick={handleClose}>
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>

                    <Grid container className={classes.gridV1}>
                        <Grid container className={classes.gridText} >
                            <Grid item className={classes.fw600}>{tripData && tripData.sourceLocation ? tripData.sourceLocation : ""}</Grid>
                            &nbsp;to&nbsp;
                            <Grid item className={classes.fw600}>{tripData && tripData.destinationLocation ? tripData.destinationLocation : ""}</Grid>
                        </Grid>
                        <Grid container className={classes.gridV2} alignItems="center">
                            <Grid item>{tripData && tripData.startDate ? getMilliDatePickerDateInStringDDMMMYYYY(tripData.startDate) : ""}</Grid>
                            <FiberManualRecordIcon className={classes.dotV1} />
                            <Grid item className={classes.divAlign}>
                                {tripData && tripData.truckNumber && getVehicleNumberValuesDWeb(tripData.truckNumber).map((vehicleNumber, index) => (
                                    <div className={index != 0 ? classes.mlV1 : ""}>{vehicleNumber}</div>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit; return (
                                <form onSubmit={handleSubmit} noValidate>
                                    <Grid container alignItems="flex-start" spacing={0}>
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />


                </DialogContent>

                <DialogActions className={classes.dialogActionsV1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Close
                    </Button>
                    <Button variant="contained" className={classes.saveButton} classes={{ disabled: classes.saveButtonDisabled }} disabled={confirmDisabled}
                        onClick={event => submit(event)}
                    >
                        Confirm
                    </Button>
                </DialogActions>

            </Dialog>

            {addChargeDeduction && <AddChargeDeductionType open={addChargeDeduction} defaultName={chargeOrDeductionType && chargeOrDeductionType.inputValue ? chargeOrDeductionType.inputValue : ""} onClose={handleAddChargeDeductionClose} onSave={handleAddChargeDeductionSave} typeValue={checkType} />}

        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchGetCharges: (onSuccess, onError) => {
        dispatch(getChargeTypes(onSuccess, onError))
    },
    dispatchGetDeductions: (onSuccess, onError) => {
        dispatch(getDeductionTypes(onSuccess, onError))
    },
    dispatchAddPartyDeductionAction: (tripId, data, onSuccess, onError) => {
        dispatch(addPartyDeduction(tripId, data, onSuccess, onError))
    },
    dispatchAddPartyChargeAction: (tripId, data, onSuccess, onError) => {
        dispatch(addPartyCharge(tripId, data, onSuccess, onError))
    },
    dispatchEditPartyDeductionAction: (tripId, deductionId, data, onSuccess, onError) => {
        dispatch(editPartyDeduction(tripId, deductionId, data, onSuccess, onError))
    },
    dispatchEditPartyCharges: (tripId, chargeId, request, onSuccess, onFailure) => {
        dispatch(editPartyCharge(tripId, chargeId, request, onSuccess, onFailure))
    }


});

export default connect(mapStateToProps, mapDispatchToProps)(AddChargeDeductionDialog);